export default __webpack_public_path__ + "742d067564eb6ce4ce96c265b2f4220a.png";